import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Welcome from "./sections/Welcome";
import Questions from "./sections/Questions";
import Spotlight from "./sections/Spotlight";
import Perspectives from "./sections/Perspectives";
import YoutubeSection from "./sections/Youtube";
import Newsletter from "./sections/Newsletter";
import Shortcode1789305925359 from "@/pages/Home/sections/Shortcode1789305925359";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Welcome />
      <Questions />
      <Spotlight />
      <Perspectives />
      <YoutubeSection />
      <Shortcode1789305925359 />
      <Newsletter />
      <Footer />
    </div>;
}